import React, { useEffect, useState } from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import Grow from '../layouts/Grow'
import Getintouch from '../layouts/Getintouch'
import { useNavigate } from "react-router-dom";
import PortfolioDetails from '../layouts/PortfolioDetails'

const Portfolio = () => {
    const platforms = [
        { name: "Shopify", image: process.env.PUBLIC_URL + "/images/portfolio-1.png" },
        { name: "Wordpress", image: process.env.PUBLIC_URL + "/images/portfolio-2.png" },
        { name: "Webflow", image: process.env.PUBLIC_URL + "/images/portfolio-3.png" },
        { name: "UI/UX", image: process.env.PUBLIC_URL + "/images/portfolio-4.png" },
        { name: "All", image: process.env.PUBLIC_URL + "/images/portfolio-5.png" }
    ];
    const [activeIndex, setActiveIndex] = useState(0);

    const handlePlatformClick = (index) => {
        setActiveIndex(index);
    };
    const navigate = useNavigate();
    const nextPlatform = () => {
        setActiveIndex((prev) => (prev + 1) % platforms.length);
    };
    useEffect(() => {
        const interval = setInterval(() => {
            nextPlatform();
        }, 3000); // Change every 3 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);
    return (
        <div>
            <Header />

            {/* <section>
                <div className="workshowcase">
                    <div className="showcase-wrapper">
                        <h2 className="showcase-title">Work Showcase</h2>
                        <div className="showcase-content">
                            <div className="text-column">
                                <div className="platform-list" id="platformList">
                                    {platforms.map((platform, index) => (
                                        <div
                                            key={index}
                                            className={`platform-item ${index === activeIndex ? 'active' : ''}`}
                                            onClick={() => handlePlatformClick(index)}
                                        >
                                            {platform.name}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="arrow-wrapper">
                                <div className="arrow-button" onClick={nextPlatform}>
                                    <i className="fas fa-arrow-right"></i>
                                </div>
                            </div>

                            <div className="image-column">
                                <img
                                    id="platformImage"
                                    src={platforms[activeIndex].image}
                                    alt={`${platforms[activeIndex].name} Showcase`}
                                />
                                <a onClick={() => navigate("/portfolio-details")} className="explore-link">
                                    Explore
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <PortfolioDetails/>
            <Grow />
            <Getintouch />
            <Footer />
        </div>
    )
}

export default Portfolio